import React from 'react'
import { IconButton, Stack } from '@mui/material'

import BaseModal from 'components/Modal/BaseModal'
import { ActionIcon, ActionTitle } from 'components/Modal/ActionModal'

export const Title = ActionTitle

export const IconTitle = ({icon, variant = 'primary'}) => (
  <ActionIcon variant={variant}>
    <i className={`fa-regular fa-${icon}`} />
  </ActionIcon>
)

const Modal = ({
                 onClose,
                 children,
                 width = 500,
               }) => {
  return (
    <BaseModal
      onClose={onClose}
      paperSx={{
        borderRadius: '16px',
        maxWidth: 'calc(100vw - 32px)',
        width
      }}
    >
      {Boolean(onClose) && (
        <IconButton
          aria-label="Fermer"
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', right: 12, top: 12 }}
        >
          <i aria-hidden="true" className="fa-light fa-xmark" style={{ fontSize: 14 }} />
        </IconButton>
      )}
      <Stack alignItems="center" gap={2} padding={4}>
        {children}
      </Stack>
    </BaseModal>
  )
}

export default Modal